import { render } from "./AccessibilityModal.vue?vue&type=template&id=8aca4706&scoped=true"
import script from "./AccessibilityModal.vue?vue&type=script&lang=js"
export * from "./AccessibilityModal.vue?vue&type=script&lang=js"

import "./AccessibilityModal.vue?vue&type=style&index=0&id=8aca4706&scoped=true&lang=scss"
import "./AccessibilityModal.vue?vue&type=style&index=1&id=8aca4706&lang=css"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aca4706"]])

export default __exports__